module.exports = __webpack_public_path__ + "static/media/under16-gift-banner-mobile.40c09e73.png";